import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, ViewChild, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig, ReportDownloadTypes } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  SurgicalTreatmentReportTableComponent,
  SurgicalTreatmentReportTableComponentModule
} from './components/surgical-treatment-report-table/surgical-treatment-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-surgical-treatments-report',
  templateUrl: './surgical-treatments-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    SurgicalTreatmentReportTableComponent,
    TranslateModule,
    AsyncPipe
  ]
})
export class SurgicalTreatmentsReportComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'SURGICAL_TREATMENTS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true,
      [ReportDownloadTypes.EXCEL_ADMIN]: true,
      [ReportDownloadTypes.EXCEL_ADMIN_ID]: true
    },
    filters: {
      status: true,
      age: true,
      gender: true,
      geography: true,
      includePhotos: true,
      organizationsTree: true,
      recordDate: true,
      referringOrganization: true,
      reportedComplications: true,
      qualityAssurance: true,
      surgeons: true,
      surgicalIntervention: true,
      repairTypes: true,
      treatmentNotCompliant: true,
      surgicalStatuses: true
    }
  };

  @ViewChild(SurgicalTreatmentReportTableComponent) surgicalTreatmentReportTableComponent: SurgicalTreatmentReportTableComponent;

  applyFilters(pagination: PaginationSortingModel) {
    this.surgicalTreatmentReportTableComponent.updateDisplayedColumns();
    this.reportTableDataService.prepareList('SURGICAL_TREATMENTS', this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    ReportFiltersModule,
    TranslateModule,
    CommonModule,
    SurgicalTreatmentReportTableComponentModule,
    GeneralCommonsModule,
    SurgicalTreatmentsReportComponent
  ],
  exports: [SurgicalTreatmentsReportComponent]
})
export class SurgicalTreatmentsReportModule {}
